import { GraphQLErrorCode } from '@cobliteam/api-lib';
import type { TFunction } from '@cobliteam/i18n';
import { parseUnprocessableEntityError } from './routingErrors';

export const parserRouteEditingErrors = (error: any, t: TFunction): string => {
  const response = error?.errors?.[0];
  const responseBody = response?.body;
  const errorMessage = responseBody?.message ? responseBody.message : '';

  if (response)
    switch (response.code) {
      case GraphQLErrorCode.INTERNAL_SERVER_ERROR:
        return parseUnprocessableEntityError(true, t, responseBody.unassigned) || parseEditErrorMessage(errorMessage) || t('routing_optimization.errors.generic');
      default:
        break;
    }

  return t('routing_optimization.errors.generic');
};

const parseEditErrorMessage = (message: string): string | undefined => {
  if (message.match("Routes that are about to start or already started can't be edited")) {
    return 'A rota que você tentou editar está prestes a começar ou já começou, o que a impede de ser editada.';
  }
  if (message.match('Route.*.not found')) {
    return 'A rota que você tentou editar não existe mais.';
  }
  if (message.match('Activity.*.not found')) {
    return 'Uma das atividades que você tentou editar não existe mais.';
  }
};
